import React, { Component } from "react";
import cn from "classnames";
import PropTypes from "prop-types";

import RadioUnchecked from "../../../containers/assets/radio-unchecked.svg";
import RadioChecked from "../../../containers/assets/radio-checked.svg";

class TeamList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedValue: props.value
    };
  }

  componentDidMount() {
    const img1Preload = new Image();
    img1Preload.src = RadioUnchecked;

    const img2Preload = new Image();
    img2Preload.src = RadioChecked;
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { id, value } = this.props;

    if (prevProps.id !== id) {
      this.setState(() => ({ selectedValue: value }));
    }
  }

  handleOnSelect = value => {
    const { selectedValue } = this.state;
    const { feedback, readonlyMode } = this.props;

    if (readonlyMode) {
      return;
    }

    if (selectedValue !== value) {
      this.setState(
        () => ({ selectedValue: value }),
        () => {
          const { onChange, id } = this.props;

          if (onChange)
            onChange({
              id,
              value,
              type: "text",
              hasError: false,
              feedback,
            });
        }
      );
    }
  };

  render() {
    const { selectedValue } = this.state;
    const { title, teamList, readonlyMode } = this.props;

    return (
      <div className="teamList">
        <div className="title">{title}</div>
        <div className="teamListItems">
          {teamList.map(({ id, username, fullname }, index) => (
            <div
              key={`team-list-item-${index}`}
              className="teamListItemWrapper"
            >
              <div
                className={cn("teamListItem", {
                  teamListItem_selected: selectedValue === username,
                  teamListItem_nofocus: readonlyMode,
                })}
                onClick={() => this.handleOnSelect(username)}
              >
                <div className="teamListItemRadio teamListItemRadioUnchecked">
                  <img
                    alt="radio-unchecked"
                    src={RadioUnchecked}
                  />
                </div>
                <div className="teamListItemRadio teamListItemRadioChecked">
                  <img
                    alt="radio-checked"
                    src={RadioChecked}
                  />
                </div>
                {fullname}
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }
}

TeamList.propTypes = {
  id: PropTypes.number,
  title: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  teamList: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    fullname: PropTypes.string,
  })),
  feedback: PropTypes.number,
  readonlyMode: PropTypes.bool,
};

export default TeamList;


// WEBPACK FOOTER //
// ./src/components/peer-evaluation/team-list/index.js